/**
 * Map preferences to their labels
 * @param {Array} preferences The preferences to transform
 * @param {Array} preferencesMap The map of preferences
 * @returns {string} The value of the preference
 */
const transformPreferences = (preferences, preferencesMap) => {
  const values = []
  preferences.forEach((preference) => {
    const option = preferencesMap?.find((opt) => opt.value === preference)
    if (option) {
      values.push({
        label: option.label,
        value: option.value
      })
    }
  })

  return values
}

export default transformPreferences
